export const cabecera = {
  da: { n: 'Diario de Almería', u: 'http://www.diariodealmeria.es/', c: 'diariodealmeria', r:'da' },
  dc: { n: 'Diario de Cádiz', u: 'http://www.diariodecadiz.es/', c: 'diariodecadiz', r:'dc' },
  dj: { n: 'Diario de Jerez', u: 'http://www.diariodejerez.es/', c: 'diariodejerez', r:'dj' },
  ds: { n: 'Diario de Sevilla', u: 'http://www.diariodesevilla.es/', c: 'diariodesevilla', r:'ds' },
  ed: { n: 'El día de Córdoba', u: 'http://www.eldiadecordoba.es/', c: 'eldiadecordoba', r:'ed' },
  es: { n: 'Europa Sur', u: 'http://www.europasur.es/', c: 'europasur', r:'es' },
  gh: { n: 'Granada Hoy', u: 'http://www.granadahoy.com/', c: 'granadahoy', r:'gh' },
  hi: { n: 'Huelva Información', u: 'http://www.huelvainformacion.es/', c: 'huelvainformacion', r:'hi' },
  mh: { n: 'Málaga hoy', u: 'http://www.malagahoy.es/', c: 'malagahoy', r: 'mh' },
  gj: { n: 'Grupo Joly', u: 'https://www.grupojoly.com/', c: 'grupojoly', r:'gj' },
};



// WEBPACK FOOTER //
// ./src/utils/cabecera.js